import { useActionData } from "react-router-dom";

interface ResponseError {
  ctx: { error: { [key: string]: string } };
  input: unknown;
  loc: string[];
  msg: string;
  type: string;
  url: string;
}

export function useValidationErrors(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any
): Record<string, string> | undefined {
  let actionData;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- allows this function to be used outside of React components
    actionData = useActionData();
  } catch (e) {
    /* empty */
  }
  data ||= actionData;
  if (data && "detail" in data) {
    const errors = data.detail as ResponseError[];
    return errors.reduce(
      (prev, curr) => ({ ...prev, [curr.loc[curr.loc.length - 1]]: curr.msg }),
      {}
    );
  }
  //   return data?.errors?.reduce(
  //     (a: object, c: any) => ({ ...a, [c.attr]: c.detail }),
  //     {}
  //   );
}
